import { Component } from '@angular/core';
import { PopupService } from '../../services/popup/popup.service';
import { environment } from '../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-legal-information-popup',
    templateUrl: './legal-information-popup.component.html',
    styleUrl: './legal-information-popup.component.sass',
    standalone: false
})

export class LegalInformationPopupComponent {

  constructor(private popupService: PopupService, private translateService: TranslateService) { }

  closePopup() {
    this.popupService.closeCurrentDialog();
  }

  private get documentLanguageCode(): 'FR' | 'EN' {
    return this.translateService.currentLang?.toLowerCase() === 'fr' ? 'FR' : 'EN';
  }

  get tcDoc() : string {
    return environment.bucket_public_url + `Terms_and_Conditions_ASOS_${this.documentLanguageCode}_June_2026.pdf`;
  }

  get cookiePolicyDoc() : string {
    return environment.bucket_public_url + `COOKIE_POLICY_${this.documentLanguageCode}_V1.pdf`;
  }

  get dataPrivacyDoc() : string {
    return environment.bucket_public_url + `DATA_PRIVACY_${this.documentLanguageCode}_V1.pdf`;
  }

}